import { useEffect, type ChangeEvent } from 'react';

import { FrontendDictionaryNames } from 'chaika-frontend-types/frontend-cms';

import { dictionaryService } from '@modules/template/services/dictionary/dictionaryService';
import { store } from '@store';
import { OptionType } from '@components/Select';
import { isDefined } from '@utils/isDefined';

import type { DescriptionFieldNames } from '@store/Task';
import type { TaskFieldData } from '@common/Task';
import { useTaskForm } from '@common/Task/TaskRightMenu/context/TaskFormContext';

interface Data {
    canEdit: boolean;
    typeOptions: OptionType<string>[];
    typeData: TaskFieldData;
    description?: string;
    onSelect(option: OptionType<string>, name: string): void;
    onChange(e: ChangeEvent<HTMLTextAreaElement>): void;
}

export function useTaskDescription(): Data {
    const { state, permissions, actions } = useTaskForm();

    useEffect(() => {
        void dictionaryService.load([FrontendDictionaryNames.TaskType]);
    }, []);

    const taskTypes = store.dictionary.getDictionary(FrontendDictionaryNames.TaskType);
    const typeId = state.type;
    const typeName = isDefined(typeId) ? taskTypes.getByValue(typeId)?.title : undefined;

    const onSelect = ({ value }: OptionType<string>, name: string): void => {
        actions.setDescriptionField(name as DescriptionFieldNames, value);
    };

    const onChange = ({ target: { value, name } }: ChangeEvent<HTMLTextAreaElement>): void => {
        actions.setDescriptionField(name as DescriptionFieldNames, value);
    };

    return {
        canEdit: permissions.canEdit && state.isEditMode,
        typeOptions: taskTypes.activeValues.flatMap(it => (it.value ? [{ label: it.title, value: it.value }] : [])),
        typeData: [typeId, typeName],
        description: state.description,
        onSelect,
        onChange,
    };
}
